import { render, staticRenderFns } from "./organism.modal.addYourImageGallery.vue?vue&type=template&id=6f7b12ca"
import script from "./organism.modal.addYourImageGallery.vue?vue&type=script&lang=ts"
export * from "./organism.modal.addYourImageGallery.vue?vue&type=script&lang=ts"
import style0 from "./organism.modal.addYourImageGallery.vue?vue&type=style&index=0&id=6f7b12ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports